import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

const MineDebatesTab = ({ debatesInfo, setVoteQuestion }) => (
  <React.Fragment>
    {debatesInfo.length > 0 ? (
      debatesInfo.map((debate, index) => {
        return (
          <div
            onClick={() => setVoteQuestion({ ...debate, onlyView: true })}
            key={index}
            className="mars--challenges__info--item"
          >
            <div className={debate.isValid ? 'icons success' : 'icons fail'}>
              <span className={debate.isValid ? 'icon-doing' : 'icon-cross'}></span>
            </div>
            <span className="text text--ellipsis">{debate.question}</span>
            <span className={debate.right ? 'result' : 'result failed'}>
              {debate.currency2 && (
                <span>
                  {debate.reward}{' '}
                  <span
                    className={`icon-${debate.currency2 == 'antimatter' ? 'antimateria' : 'coin'}`}
                  />
                </span>
              )}
              <span>
                {debate.reward}{' '}
                <span
                  className={`icon-${debate.currency == 'antimatter' ? 'antimateria' : 'coin'}`}
                />
              </span>
              <span>
                {debate.right ? (
                  <FormattedMessage id="phase.mineTab.won" />
                ) : (
                  <FormattedMessage id="phase.mineTab.lost" />
                )}
              </span>
            </span>
          </div>
        )
      })
    ) : (
      <div>
        <span className="text">
          <FormattedMessage id="phase.informationPhase_No_Debate" />
        </span>
      </div>
    )}
  </React.Fragment>
)

MineDebatesTab.propTypes = {
  debatesInfo: PropTypes.array,
  setVoteQuestion: PropTypes.func,
}

export default injectIntl(MineDebatesTab)
